import { useMemo } from 'react'
import { useRealm } from './use-realm'
import { useTheme as useRealmTheme } from '@tecsinapse-org/portal-menu-kit'

export const useTheme = () => {
  const _realm = useRealm()
  const realm = useMemo(() => (_realm ? _realm.toLowerCase() : null), [_realm])

  return useRealmTheme(realm)
}
